"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Types = void 0;
const v2_1 = require("../../v2");
const v2 = v2_1.Types.Api.Types;
class Types {
    static AgreementsSchema;
    static GeneralSchema;
    static NodeSchema;
    static CardSchema;
    static ContactSchema;
    static ProfileSchema;
    static SecuritySchema;
    static StateSchema;
    static UserSchema;
    static AppSchema;
    static PreferenceSchema;
    static VaultSchema;
    static MountedUserSchema;
    static SecurityTypes;
    static SecurityLevel;
    static Blank;
}
exports.Types = Types;
//# sourceMappingURL=index.js.map